import { api, LightningElement } from "lwc";

import { createTrack } from "common/track";

import { FooterGlobal, FooterLink } from "./types";

export default class extends LightningElement {
  @api content: FooterGlobal = null!;

  private track = createTrack<"tds-footer-global">(this);

  private get renderLeft() {
    return this.content.logo || this.content.copyright;
  }

  private get links() {
    return this.content.links.map((link) =>
      Object.assign({}, link, {
        handleClick: this.handleLinkClick.bind(this, link),
      })
    );
  }

  private handleLinkClick(link: FooterLink) {
    // Keep for backwards compatibility
    this.dispatchEvent(new CustomEvent("link_click", { detail: link }));
    this.track("link_clicked", { label: link.label });
  }
}
